module.exports = __webpack_public_path__ + "static/img/caterium-ingot_256.8cf4d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caterium-ingot_256.png
// module id = B0l0
// module chunks = 0